// Triggered when the form is submitted
//
const onFormSubmitted = function () {
  document.getElementById("bulk-verification-form").addEventListener("turbo:submit-start", function () {
    App.analytics.ga_track("Bulk Email Verification", "Creation")
  })
}

document.addEventListener("turbo:load", function () {
  if (!App.currentPageIs("bulk_verifications", "new")) {
    return
  }

  onFormSubmitted()
})
